import React from 'react';
import PropTypes from 'prop-types';
import {EmailShareButton, EmailIcon, FacebookIcon, TwitterIcon, WhatsappIcon, FacebookShareButton, TwitterShareButton, WhatsappShareButton,} from "react-share";

const ShareButtons = ({url}) => {
    console.log(url)
    return (
        <div className='share-buttons'>
            <EmailShareButton  url={url}><EmailIcon size={32} round={true} /></EmailShareButton>
            <FacebookShareButton quote='View this Infographic from Delhi Covid Care: ' url={url}><FacebookIcon size={32} round={true} /></FacebookShareButton>
            <TwitterShareButton url={url}><TwitterIcon size={32} round={true} /></TwitterShareButton>
            <WhatsappShareButton url={url}><WhatsappIcon size={32} round={true} /></WhatsappShareButton>
        </div>
    )
}

ShareButtons.propTypes = {
    url: PropTypes.string.isRequired,
};

export default ShareButtons;
